/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable max-len */
import { motion } from 'framer-motion';
import React from 'react';

export default function OfferToolTip({ prod, hover, OrderDetails }) {
    return (
        <motion.div
            initial={{ opacity: 0, scale: 0.5 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{
                duration: 0.8,
                delay: 0.5,
                ease: [0, 0.71, 0.2, 1.01],
            }}
            id="tooltip-discountPercentage"
            role="tooltip"
            className={`inline-block absolute ${hover ? 'visible' : 'invisible'} z-10 sm:pl-5 sm:pr-4 px-2 pb-2 sm:pt-4 pt-2.5 bg-white rounded-lg shadow-s2 w-[210px]`}
        >
            <p className="text-xs font-bold text-[#090406]">Offer Applied</p>
            <>
                {prod?.offer_type
            && (
                <button
                    type="button"
                    className="text-sm font-semibold text-[#FFFFFF] bg-[#44445E] rounded pr-1 px-1 w-fit absolute right-0 top-2 mr-2 mt-2 "
                    style={{
                        opacity: 1, transform: 'none', fontSize: '10px', background: '#44445E',
                    }}
                >
                    {prod?.offer_type}
                </button>
            )}

            </>
            <p className="text-xs font-semibold text-[#555259] pt-[3px]">
                {prod?.deal}
                {' '}
                |Criteria-
                {Number(prod?.criteria) + 1}
            </p>
            <div className="flex items-center justify-between pt-2.5">
                <p className="text-sm font-normal text-[#555259]">Trade Discount</p>
                <p className="text-lg font-semibold text-[#555259]">
                    {prod?.trade_discount_type === '₹' ? (['Trade', 'Trade EUB'].includes(OrderDetails.order_type) ? Number(prod?.trade_discount_applied || 0) : 0).toLocaleString('en-IN', {
                        style: 'currency',
                        currency: 'INR',
                    }) : `${['Trade', 'Trade EUB'].includes(OrderDetails.order_type) ? prod?.trade_discount || 0 : 0}%`}
                </p>
            </div>
            <div className="flex items-center justify-between pt-1">
                <p className="text-sm font-normal text-[#555259]">Additional Discount </p>
                <p className="text-lg font-semibold text-[#555259]">
                    {prod?.trade_discount_type === '₹' ? Number(['Trade', 'Trade EUB'].includes(OrderDetails.order_type) ? prod?.additinal_discount_applied : prod?.trade_discount_applied || 0).toLocaleString('en-IN', {
                        style: 'currency',
                        currency: 'INR',
                    }) : `${['Trade', 'Trade EUB'].includes(OrderDetails.order_type) ? prod?.additinal_discount : prod?.trade_discount || 0}%`}
                </p>
            </div>
            <div className="tooltip-arrow" data-popper-arrow />
        </motion.div>
    );
}
